import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

type Props = {
  onPress: () => void;
};

export default function AppHeaderLeaveButton({ onPress }: Props) {
  return (
    <TouchableOpacity
      style={styles.leave}
      onPress={onPress}
      hitSlop={8}
      accessibilityRole="button"
      accessibilityLabel="Leave conversation"
    >
      <Text style={styles.leaveText}>LEAVE</Text>
      <View style={styles.leaveIcon}>
        <Ionicons name="close" size={20.152759552001953} color="#fff" />
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  leave: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  leaveText: {
    color: "#ff5a5f",
    fontFamily: "Lexend",
    fontWeight: "700",
    fontSize: 19,
    // A line height below the font size clipped the top of the letters on
    // iOS (#142).
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: "right",
    includeFontPadding: false,
  },
  leaveIcon: {
    width: 36,
    height: 36,
    borderRadius: 18,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ff5a5f",
  },
  leaveIconText: {
    color: "#fff",
    fontFamily: "Lexend",
    fontWeight: "700",
    fontSize: 19,
    lineHeight: 19, // важно: не 23
    textAlign: "center",
    includeFontPadding: false, // Android фикс
    // textAlignVertical: "center", // можно включить, но это только Android
  },
});
